import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { ContactOption } from "../../../api/firebase/types/scenario.types";
import ContactGroupSelectionModalStore from "../../../store/ContactGroupSelectionModalStore";
import ContactGroupStore from "../../../store/ContactGroupStore";
import ContactOptionTable from "../../../components/table/ContactOptionTable";
import ContactService from "../../../util/ContactService";
import ContactGroupSelectionModal from "../../../components/dialogs/ContactGroupSelectionModal";

type GroupContactOptionTableProps = {
  contactGroupSettings: Map<ContactOption, string[]>;
  onSettingsChange: (settings: Map<ContactOption, string[]>) => void;
  description?: string;
};

const GroupContactOptionTable: React.FC<GroupContactOptionTableProps> = ({
  contactGroupSettings,
  onSettingsChange,
  description,
}) => {
  const { getContactGroupsById } = ContactGroupStore;
  const { setGroupParams } = ContactGroupSelectionModalStore;

  const scenarioContactGroupIds =
    ContactService.getAllUniqueIds(contactGroupSettings);

  const onContactGroupSelection = (groupIds: string[]) => {
    const updatedGroupSettings = ContactService.processIncomingIds(
      groupIds,
      contactGroupSettings
    );
    onSettingsChange(updatedGroupSettings);
  };

  return (
    <>
      <Toolbar
        left={() => <h3 className="p-mb-0">Kontaktgruppen</h3>}
        right={() => (
          <Button
            label="Kontaktgruppen auswählen"
            icon="pi pi-plus"
            className="p-button-text p-mr-2"
            onClick={() =>
              setGroupParams(scenarioContactGroupIds, onContactGroupSelection)
            }
          />
        )}
      />
      {description && (
        <p>
          <i>{description}</i>
        </p>
      )}
      <ContactOptionTable
        contactSettings={contactGroupSettings}
        value={getContactGroupsById(scenarioContactGroupIds)}
        onChange={onSettingsChange}
      >
        <Column field="label" header="Bezeichnung" />
      </ContactOptionTable>
      <ContactGroupSelectionModal />
    </>
  );
};

export default GroupContactOptionTable;
